import React from "react";
import '../../styles/bootstrap-import.scss';

const StyleWrapper = ({children}) => {
    return (
        <div>{children}</div>
    );
}
export default StyleWrapper;